import React from 'react';
export function Footer() {
  return <footer className="bg-[#050b14] py-12 border-t border-slate-800 text-center" data-id="element-147">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <p className="text-slate-500 text-sm mb-4" data-id="element-149">
          © 2025 Megapack Columna Activa — Todos los derechos reservados
        </p>
        <p className="text-slate-500 text-sm mb-8" data-id="element-150">
          Contacto: soporte@columnaactiva.com | @columnaactiva
        </p>
        <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-800 inline-block" data-id="element-151">
          <p className="text-slate-400 text-xs leading-relaxed max-w-2xl" data-id="element-152">
            Este producto es educativo y complementario. No reemplaza el
            diagnóstico ni el tratamiento médico profesional. Consulte siempre a
            su médico o kinesiólogo antes de comenzar cualquier programa de
            ejercicios.
          </p>
        </div>
      </div>
    </footer>;
}